export const newLicenseSideBarItems = [
  {
    id: 1,
    name: "Apply For New License",
    path: "/Applicant/NewLicense",
    icon: "bx bx-plus",
  },
  {
    id: 2,
    name: "Submitted",
    path: "/Applicant/NewLicense/submitted",
    icon: "bx bx-save",
  },
  {
    id: 3,
    name: "Draft",
    path: "/Applicant/NewLicense/draft",
    icon: "bx bx-paste",
  },
  {
    id: 4,
    name: "Withdraw",
    path: "/Applicant/NewLicense/withdraw",
    icon: "bx bx-x-circle",
  },
  {
    id: 5,
    name: "In Review",
    path: "/Applicant/NewLicense/inReview",
    icon: "bx bx-refresh",
  },
  {
    id: 6,
    name: "Approved",
    path: "/Applicant/NewLicense/approved",
    icon: "bx bx-badge-check",
  },
  {
    id: 7,
    name: "Declined",
    path: "/Applicant/NewLicense/declined",
    icon: "bx bx-shield-x",
  },
  {
    id: 8,
    name: "Under Supervision",
    path: "/Applicant/NewLicense/underSupervision",
    icon: "bx bx-glasses",
  },
  {
    id: 9,
    name: "Returned",
    path: "/Applicant/NewLicense/returned",
    icon: "bx bx-rotate-left",
  },
  {
    id: 10,
    name: "Suspended",
    path: "/Applicant/NewLicense/suspended",
    icon: "bx bx-stop-circle",
  },
  {
    id: 11,
    name: "Revoked",
    path: "/Applicant/NewLicense/revoked",
    icon: "bx bx-trash-alt",
  },
];

export const renewalSideBarItems = [
  {
    id: 1,
    name: "Apply For Renewal",
    path: "/Applicant/Renewal",
    icon: "bx bx-plus",
  },
  {
    id: 2,
    name: "Submitted",
    path: "/Applicant/Renewal/submitted",
    icon: "bx bx-save",
  },
  {
    id: 3,
    name: "Draft",
    path: "/Applicant/Renewal/draft",
    icon: "bx bx-paste",
  },
  {
    id: 4,
    name: "Withdraw",
    path: "/Applicant/Renewal/withdraw",
    icon: "bx bx-x-circle",
  },
  {
    id: 5,
    name: "In Review",
    path: "/Applicant/Renewal/inReview",
    icon: "bx bx-refresh",
  },
  {
    id: 6,
    name: "Approved",
    path: "/Applicant/Renewal/approved",
    icon: "bx bx-badge-check",
  },
  {
    id: 7,
    name: "Declined",
    path: "/Applicant/Renewal/declined",
    icon: "bx bx-shield-x",
  },
  {
    id: 8,
    name: "Under Supervision",
    path: "/Applicant/Renewal/underSupervision",
    icon: "bx bx-glasses",
  },
  {
    id: 9,
    name: "Returned",
    path: "/Applicant/Renewal/returned",
    icon: "bx bx-rotate-left",
  },
  {
    id: 10,
    name: "Suspended",
    path: "/Applicant/Renewal/suspended",
    icon: "bx bx-stop-circle",
  },
  {
    id: 11,
    name: "Revoked",
    path: "/Applicant/Renewal/revoked",
    icon: "bx bx-trash-alt",
  },
];

export const gSSideBarItems = [
  {
    id: 1,
    name: "Apply For Good Standing",
    path: "/Applicant/GoodStanding",
    icon: "bx bx-plus",
  },
  {
    id: 2,
    name: "Submitted",
    path: "/Applicant/GoodStanding/submitted",
    icon: "bx bx-save",
  },
  {
    id: 3,
    name: "Draft",
    path: "/Applicant/GoodStanding/draft",
    icon: "bx bx-paste",
  },
  {
    id: 4,
    name: "Withdraw",
    path: "/Applicant/GoodStanding/withdraw",
    icon: "bx bx-x-circle",
  },
  {
    id: 5,
    name: "In Review",
    path: "/Applicant/GoodStanding/assigned",
    icon: "bx bx-refresh",
  },
  {
    id: 6,
    name: "Approved",
    path: "/Applicant/GoodStanding/approved",
    icon: "bx bx-badge-check",
  },
  {
    id: 7,
    name: "Declined",
    path: "/Applicant/GoodStanding/declined",
    icon: "bx bx-shield-x",
  },
];
export const LLicenseSideBarItems = [
  {
    id: 1,
    name: "Apply For Lost License",
    path: "/Applicant/LostLicense",
    icon: "bx bx-plus",
  },
  {
    id: 2,
    name: "Submitted",
    path: "/Applicant/LostLicense/submitted",
    icon: "bx bx-save",
  },
  {
    id: 3,
    name: "Declined",
    path: "/Applicant/LostLicense/declined",
    icon: "bx bx-paste",
  },
];
export const profileSideBarItems = [
  {
    id: 1,
    name: "Profile",
    path: "/applicant/profile",
    icon: "bx bx-user",
  },
]